const testimonials = [
  { q:"On ne rate plus aucun appel, même pendant les visites. Chaque demande arrive déjà contextualisée.", name:"Caroline B.", role:"Directrice d'agence — Toulouse" },
  { q:"Je gagne du temps sur les demandes qui n'ont pas de projet défini, sans laisser sonner dans le vide.", name:"Julien R.", role:"Responsable transaction — Montpellier" },
  { q:"Sur le locatif, savoir ce qu'il y a derrière l'appel avant de rappeler change vraiment la journée.", name:"Sophie M.", role:"Gestionnaire locatif — Lille" },
];

const Testimonials = () => (
  <section id="testimonials" className="py-16 md:py-20 lg:py-24">
    <div className="mx-auto max-w-[1344px] px-5 md:px-8">
      <div className="grid gap-10 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <p className="eyebrow">Sur le terrain</p>
          <h2 className="mt-5 max-w-[390px] text-3xl font-semibold tracking-[-.03em] md:text-[42px] md:leading-[1.06]">Pensé pour les journées qui ne se passent jamais comme prévu.</h2>
        </div>

        <div className="lg:col-span-7 lg:col-start-6">
          <figure className="border-y border-foreground/20 py-8">
            <blockquote className="text-[27px] leading-[1.4] tracking-[-.025em] md:text-[34px]">
              « {testimonials[0].q} »
            </blockquote>
            <figcaption className="mt-7 text-[14px]">
              <b>{testimonials[0].name}</b>
              <span className="ml-2 text-muted-foreground">{testimonials[0].role}</span>
            </figcaption>
          </figure>

          <div className="grid md:grid-cols-2">
            {testimonials.slice(1).map((t, i) => (
              <figure key={t.name} className={"py-7 md:px-7 " + (i === 0 ? "border-b border-border md:border-b-0 md:border-r" : "")}>
                <span className="font-mono text-[10px] text-primary">0{i+2}</span>
                <blockquote className="mt-4 text-[17px] leading-7">« {t.q} »</blockquote>
                <figcaption className="mt-5 text-[14px]">
                  <b className="block">{t.name}</b>
                  <span className="text-muted-foreground">{t.role}</span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);
export default Testimonials;